import React, { useContext } from 'react';
import { CONFIG } from 'config/config';
import { PickerHOC, NavigationWrapper } from '@coinscrap/webapp-core';
import LoadingScreen from 'components/LoadingScreen/LoadingScreen';
import { AgentContext } from '../../../contexts/agent';

export const Bmw = PickerHOC(
	{},
	LoadingScreen,
)(() => {
	const { setBmwValues } = useContext(AgentContext);
	const { navigateTo } = NavigationWrapper.use();
	setBmwValues();
	CONFIG.routing.personalized.next(navigateTo, 'bmw');

	return <></>;
});
